// src/sections/Contact/Contact.js
import React from 'react';
import styles from './Contact.module.css';

const Contact = ({ id }) => {
  const openingHours = [
    { day: "Lundi", hours: "9h00-14h00" },
    { day: "Mardi", hours: "9h00-14h00" },
    { day: "Mercredi", hours: "9h00-14h00" },
    { day: "Jeudi", hours: "9h00-14h00" },
    { day: "Vendredi", hours: "9h00-14h00 / 18h00-21h00" },
    { day: "Samedi", hours: "9h00-14h00" },
    // Dimanche n'est pas mentionné, on le suppose fermé ou non renseigné
  ];

  return (
    <section id={id} className={styles.contact}>
      <div className={styles.container}>
        <div className={styles.contentGrid}>
          <div className={styles.contactInfo}>
            <h3 className={styles.infoTitle}>NOUS CONTACTER</h3>
            <p className={styles.address}>
              15 Place du 8 Mai 1945<br />
              32200 SAMATAN
            </p>
            <p className={styles.phone}>
              Tél: <a href="tel:+33698012529">06.98.01.25.29</a>
            </p>

            <h3 className={styles.infoTitle}>HEURES D'OUVERTURE</h3>
            <ul className={styles.hoursList}>
              {openingHours.map((item, index) => (
                <li key={index}>
                  <span className={styles.day}>{item.day}</span>: <span className={styles.hours}>{item.hours}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className={styles.mapSection}>
            <h3 className={styles.infoTitle}>PLAN</h3>
            <div className={styles.mapContainer}>
              {/* Placeholder pour la carte Google Maps.
                  Remplacez le src par votre propre embed de Google Maps pour une carte interactive.
                  Pour obtenir l'embed : Allez sur Google Maps, cherchez l'adresse, cliquez sur "Partager",
                  puis "Intégrer une carte" et copiez le code iframe.
              */}
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2879.4674063233633!2d0.8878945763072793!3d43.469774371101965!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12a9e22e9603f7e5%3A0x6b8c8d8b6d8d6d8d!2s15%20Place%20du%208%20Mai%201945%2C%2032130%20Samatan!5e0!3m2!1sfr!2sfr!4v1718529321485!5m2!1sfr!2sfr"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Google Map Le Poké Samatan"
              ></iframe>
            </div>
            <a 
              href="https://www.google.com/maps/place/15+Place+du+8+Mai+1945,+32130+Samatan/@43.4697744,0.8878946,17z/data=!3m1!4b1!4m6!3m5!1s0x12a9e22e9603f7e5:0x6b8c8d8b6d8d6d8d!8m2!3d43.4697744!4d0.8904695!16s%2Fg%2F11b8_d5f9w?entry=ttu" 
              target="_blank" 
              rel="noopener noreferrer" 
              className={styles.mapLink}
            >
              Agrandir le plan
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;